// extracted by mini-css-extract-plugin
export default {"root":"popover-module___root___e1938c1b"};